type Props = {
  'data-test'?: string;
  color?: string;
  height?: string;
};

function Replay({ color = 'black', height = '21', ...props }: Props) {
  return (
    <svg
      fill="none"
      height={height}
      viewBox="0 0 17 21"
      width="17"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <path
        d="M8.00003 4.00003V1.21003C8.00003 0.760031 7.46003 0.540031 7.15003 0.860031L3.35003 4.65003C3.15003 4.85003 3.15003 5.16003 3.35003 5.36003L7.14003 9.15003C7.46003 9.46003 8.00003 9.24003 8.00003 8.79003V6.00003C11.73 6.00003 14.68 9.42003 13.86 13.29C13.39 15.56 11.55 17.39 9.29003 17.86C5.72003 18.61 2.54003 16.16 2.06003 12.85C1.99003 12.37 1.57003 12 1.08003 12C0.480028 12 2.79993e-05 12.53 0.080028 13.13C0.700028 17.52 4.88003 20.77 9.61003 19.85C12.73 19.24 15.24 16.73 15.85 13.61C16.84 8.48003 12.94 4.00003 8.00003 4.00003Z"
        fill={color}
      />
    </svg>
  );
}

export default Replay;
